export default "__VITE_ASSET__KbR$BLQA__"